// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-o_gc","galleryThumbnail_active":"c-o_ge","galleryThumbnail__image":"c-o_gf"};